import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { DocumentReglementaire } from '@/models/DocumentReglementaire';
import dayjs from 'dayjs';
import { TypeDocumentReglementaire } from '@/models/TypeDocumentReglementaire';
import { AnalyseDeRisqueDTO } from '@/models/AnalyseDeRisqueDTO';
import { PriseEnChargeDTO } from '@/models/PriseEnChargeDTO';

export interface DocumentReglementaireState {
    typeDocumentList: TypeDocumentReglementaire[];
    tableHeader: TableHeader[];
    tableAdrHeader: TableHeader[];
    tablePecHeader: TableHeader[];
    page: number;
    nbOfPages: number;
    scroll: number;
    count: number;
    documentReglementaire: DocumentReglementaire[];
    adr: AnalyseDeRisqueDTO[];
    prisesEnCharge: PriseEnChargeDTO[];
    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    isLoading: boolean;
    isZipLoading: boolean;
    filterSite: number[];
    filterDocumentType: TypeDocumentReglementaire[];
    filterGroupe: number[];
    filterSousGroupe: number[];
    filterEquipement: number[];
    filterDocumentDateFrom: string;
    filterDocumentDateTo: string;
    documentIdsToDownload: number[];
    error?: Error;
    nombreDocumentModal: number;
    typesDocumentsReglementaires: TypeDocumentReglementaire[];
}

export const initialState: DocumentReglementaireState = {
    typeDocumentList: [],
    documentReglementaire: [],
    adr: [],
    prisesEnCharge: [],
    tableHeader: [
        {
            label: '',
            sortData: 'uniqueDocumentId',
            sortStatus: SortType.INACTIVE,
            width: '5%',
        },
        {
            label: 'document.reglementaire.data.libelle',
            sortData: 'interventionId',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'document.reglementaire.data.type',
            sortData: 'typesDocumentsReglementaire',
            sortStatus: SortType.INACTIVE,
            width: '15%',
        },
        {
            label: 'document.reglementaire.data.site',
            sortData: 'adresseProjetDescription',
            sortStatus: SortType.NONE,
            width: '17%',
        },
        {
            label: 'document.reglementaire.data.groupe',
            sortData: 'groupeLibelle',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'document.reglementaire.data.sousgroupe',
            sortData: 'sousGroupeLibelle',
            sortStatus: SortType.NONE,
            width: '12%',
        },
        {
            label: 'document.reglementaire.data.equipement',
            sortData: 'libelleEquipement',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'document.reglementaire.data.date',
            sortData: 'dateIntervention',
            sortStatus: SortType.DESC,
            width: '10%',
        },
    ],
    tableAdrHeader: [
        {
            label: '',
            sortData: 'uniqueDocumentId',
            sortStatus: SortType.INACTIVE,
            width: '5%',
        },
        {
            label: 'analyse.risque.table.id',
            sortData: 'id',
            sortStatus: SortType.DESC,
            width: '15%',
        },
        {
            label: 'analyse.risque.table.site',
            sortData: 'libelleSite',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'analyse.risque.table.date.creation',
            sortData: 'dateCreation',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'analyse.risque.table.date.debut.validite',
            sortData: 'dateDebut',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'analyse.risque.table.date.fin.validite',
            sortData: 'dateFin',
            sortStatus: SortType.NONE,
            width: '20%',
        },
    ],
    tablePecHeader: [
        {
            label: 'priseEnCharge.table.libelle',
            sortData: 'titre',
            sortStatus: SortType.INACTIVE,
            width: '30%',
        },
        {
            label: 'priseEnCharge.table.projet',
            sortData: 'libelleChantier',
            sortStatus: SortType.INACTIVE,
            width: '30%',
        },
        {
            label: 'priseEnCharge.table.date.miseAjourjour',
            sortData: 'dateMiseAJour',
            sortStatus: SortType.INACTIVE,
            width: '25%',
        },
        {
            label: 'priseEnCharge.table.document.pdf',
            sortData: 'pdfExist',
            sortStatus: SortType.INACTIVE,
            width: '15%',
            textalign: 'center',
        },
    ],
    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    sort: {
        sortData: 'dateIntervention',
        sortStatus: SortType.DESC,
    },

    filterSite: [],
    filterDocumentType: [],
    filterGroupe: [],
    filterSousGroupe: [],
    filterEquipement: [],
    documentIdsToDownload: [],
    filterDocumentDateFrom: dayjs().startOf('year').format('YYYY-MM-DD'),
    filterDocumentDateTo: dayjs().endOf('year').format('YYYY-MM-DD'),

    isLoading: false,
    isZipLoading: false,
    nombreDocumentModal: 0,
    typesDocumentsReglementaires: [],
};

export const state: DocumentReglementaireState = {
    ...initialState,
};
